import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {RootState} from '../../../redux/store.type';
import * as css from './CoverContent.css';
import DateTimeItem from './DateTimeItem';
import Calendar from '../../../assets/icons/Calendar';
import Clock from '../../../assets/icons/Clock';
import {getDateFormat, getHourMinutes, toUnixSec} from '../../../library/dates';

function CoverContent() {
    const {t} = useTranslation('eTicket');
    const event = useSelector((s: RootState) => s.eTicket.data?.event);
    if(!event)
        return null;

    const start = toUnixSec(event.timeStart);
    const open = toUnixSec(event.timeOpen);
    const items = [
        {key: 'date', label: t('date'), value: Number.isNaN(start) ? '' : getDateFormat(start, 'DD.MM.YY'), icon: <Calendar />},
        {key: 'start', label: t('startsAt'), value: Number.isNaN(start) ? '' : getHourMinutes(start), icon: <Clock />},
        {key: 'gates', label: t('gatesOpen'), value: Number.isNaN(open) ? '' : getHourMinutes(open), icon: <Clock />}
    ].filter(item => item.value);

    return (
        <css.content data-cy="ticket-cover-content">
            <css.poster>
                {event.image && <img src={event.image} alt={event.title} />}
            </css.poster>
            <css.details>
                <css.title>{event.title}</css.title>
                {!!items.length && (
                    <css.dateTime>
                        {items.map(item => (
                            <DateTimeItem key={item.key} label={item.label} value={item.value} icon={item.icon} data-cy={`cover-${item.key}`} />
                        ))}
                    </css.dateTime>
                )}
                {event.location && <css.venue>{event.location}</css.venue>}
            </css.details>
        </css.content>
    );
}

export default CoverContent;
